import { Component, forwardRef } from '@angular/core';
import { TeamService } from '../../service/team.service';
import { combineLatest, map, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { validatedProfielId } from 'parkour-web-app-dto';
import { ContextService } from '../../../shared/services/context.service';
import { TeamlidProfiel } from '../../model/teamlid.model';
import { TranslateModule } from '@ngx-translate/core';
import { ProfielnaamPipe } from '../../../shared/pipes/profielnaam.pipe';
import { ParkourBackButtonDirective } from '../../../shared/directives/parkour-back-button.directive';
import { ParkourHeaderActionComponent } from '../../../shared/components/parkour-header-action/parkour-header-action.component';
import { AsyncPipe } from '@angular/common';
import { PageWithGradientHeroComponent } from '../../../shared/components/page-with-gradient-hero/page-with-gradient-hero.component';
import { ProfielFotoComponent } from '../../../shared/components/profiel-foto/profiel-foto.component';
import { ParkourInfoCardComponent } from '@parkour/ui';
import { DeelDetailsListComponent } from '../../component/deel-details-list/deel-details-list.component';
import { PageLayoutComponent } from '../../../shared/components/page-layout/page-layout.component';
import { PageContentDirective } from '../../../shared/directives/page-content.directive';
import { ProfielDetailsComponent } from '../../../profiel/component/profile-details/profiel-details.component';
import { getProfielnaam } from '../../../profiel/model/profiel-in-team';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ParkourRefreshDirective } from '../../../shared/directives/parkour-refresh-directive';
import { ParkourDataPage } from '../../../shared/parkour-data-page';
import { ShowIfSuccesfulDirective } from '../../../shared/directives/show-if-succesful.directive';
import { ProfielDetailsAfwezigheidCardComponent } from '../../../profiel/component/profiel-details-afwezigheid-card/profiel-details-afwezigheid-card.component';
import { RolLabelPipe } from '../../../shared/pipes/rol-label.pipe';
import { ProfielDetailsGeverifieerdCardComponent } from '../../../profiel/component/profiel-details-geverifieerd-card/profiel-details-geverifieerd-card.component';

export type TeamlidDetailsPageData = {
  teamlid: TeamlidProfiel;
  isJongere: boolean;
};

@Component({
  standalone: true,
  templateUrl: './teamlid-details.page.html',
  imports: [
    ParkourBackButtonDirective,
    TranslateModule,
    ParkourHeaderActionComponent,
    AsyncPipe,
    PageWithGradientHeroComponent,
    ProfielnaamPipe,
    ProfielFotoComponent,
    ParkourInfoCardComponent,
    DeelDetailsListComponent,
    PageLayoutComponent,
    forwardRef(() => PageContentDirective),
    ProfielDetailsComponent,
    IonRefresher,
    IonRefresherContent,
    IonContent,
    ParkourRefreshDirective,
    IonBackButton,
    IonButtons,
    IonTitle,
    IonToolbar,
    IonHeader,
    ShowIfSuccesfulDirective,
    ProfielDetailsAfwezigheidCardComponent,
    RolLabelPipe,
    ProfielDetailsGeverifieerdCardComponent,
  ],
})
export class TeamlidDetailsPage extends ParkourDataPage<TeamlidDetailsPageData> {
  constructor(
    private teamService: TeamService,
    private contextService: ContextService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  override retrieveMainData(): Observable<TeamlidDetailsPageData> {
    return combineLatest({
      teamlid: this.teamService.getTeamlidInCurrentContext(
        validatedProfielId(this.route.snapshot.paramMap.get('teamlidId')),
      ),
      isJongere: this.contextService.context$.pipe(map((context) => context.type === 'jongere')),
    });
  }

  getCustomPageTitle() {
    return this.generateDefaultTitle(
      (data) => getProfielnaam(data.teamlid),
      'team.teamlid-detail-page.title',
      true,
    );
  }
}
